import React, { ReactElement } from 'react';
import classNames from 'classnames';
import { Button } from 'b2b-components/theme/components/Button';
import { ContentControlButtonsProps } from './index';
import './ContentControlButtons.scss';

export const ContentControlButtons = ({
  onClose,
  closeLabel,
  onConfirm,
  confirmLabel,
  hideConfirmButton,
  className,
}: ContentControlButtonsProps): ReactElement => (
  <div className={classNames('ContentControlButtons', className)}>
    {onClose && closeLabel && (
      <Button
        className='ContentControlButton'
        size={Button.config.size.small}
        styleType={Button.config.styleType.light}
        onClick={onClose}
      >
        {closeLabel}
      </Button>
    )}

    {!hideConfirmButton && onConfirm && confirmLabel && (
      <Button
        className='ContentControlButton'
        size={Button.config.size.small}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    )}

  </div>
);
